import Tech from "../assets/Group.svg" ;
import Easy from "../assets/Group-1.svg" ;
import Price from "../assets/Group-2.svg" ;
import Zero from "../assets/Group 3.svg" ;

const Udata = [
    {
        img:Tech,
        heading:"Technology with Human Touch",
        content:" We are Cruise first online travel agency, but value the importance of human connect. So feel free to look and chat with us "
    },
     {
        img:Price,
        heading:"Best Price Guarantee",
        content:" Book with confidence as our network get’s us the best deal out there."

     },
     {
        img:Easy,
        heading:"Easy Booking and Cancellation",
        content:" Hold a booking free till you make your mind and free cancellation before 90 days to sailing. "

     },
     {
        img:Zero,
        heading:"Zero Service Charge",
        content:" Multiple payment options with credit and debit cards EMI, wallets and bank transfers and you get our expertise."

     }
]


export default Udata ;
